// Union of the InApp states and the LOM/physical-store states (v3/data/store/contracting/enums.ts),
// since the unified Online flow renders contracts from both origins.
export enum OnlineContractingStateEnum {
  ContractingStarted = 'CONTRATACAO_INICIADA',
  ContractingDenied = 'CONTRATACAO_NEGADA',
  ProcessingCreditAnalysis = 'PROCESSANDO_ANALISE_CREDITO',
  CreditAnalysisRejected = 'ANALISE_CREDITO_REPROVADA',
  WaitingProposalGeneration = 'AGUARDANDO_GERACAO_PROPOSTA',
  WaitingDocuments = 'AGUARDANDO_DOCUMENTOS',
  WaitingSelfie = 'AGUARDANDO_SELFIE',
  CafRejected = 'CAF_REPROVADA',
  WaitingRegistrationData = 'AGUARDANDO_DADOS_CADASTRAIS',
  CpfBlocked = 'CPF_BLOQUEADO',
  WaitingProposalAcceptance = 'AGUARDANDO_ACEITE_PROPOSTA',
  WaitingTermsAcceptance = 'AGUARDANDO_ACEITES_TERMOS',
  ProcessingAntiFraud = 'PROCESSANDO_ANTIFRAUDE',
  WaitingContractEffectiveness = 'AGUARDANDO_EFETIVACAO_CONTRATO',
  WaitingDownPayment = 'AGUARDANDO_PAGAMENTO_ENTRADA',
  WaitingBilling = 'AGUARDANDO_FATURAMENTO',
  ProcessingBilling = 'PROCESSANDO_FATURAMENTO',
  ProcessingCancellation = 'PROCESSANDO_CANCELAMENTO',
  ContractingFinished = 'CONTRATACAO_FINALIZADA',
  ExpiredKey = 'CHAVE_EXPIRADA',
  ContractingCanceled = 'CONTRATACAO_CANCELADA',
}

export enum CreditSimulationOriginEnum {
  InApp = 'InApp',
  LOM = 'LOM',
}

export enum ContractingStatusColorEnum {
  undefined = 'warning',
  ContractingFinished = 'info',
  CreditAnalysisRejected = 'blue',
  CafRejected = 'green',
  CpfBlocked = 'tertiary',
  ContractingDenied = 'error',
}
